var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gp-detail-nav"},[_c('div',{staticClass:"detail-nav_option",on:{"click":_vm.navigateBack}},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('button',[_vm._v("返回")])]),_c('div',{staticClass:"detail-nav_line"}),_c('div',{staticClass:"detail-nav_title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }